import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map, Observable, startWith } from 'rxjs';
import { CadastroGenerico } from 'src/app/models/cad/cadastro-generico/cadastro-generico';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CadastroGenericoService } from 'src/app/services/cad/cadastro-generico.service';
import { TrataExcessao } from '../../utils/trata-excessao';
import { CustomSnackBarService } from '../custom-snack-bar/custom-snack-bar.service';

@Component({
  selector: 'app-justificativa-modal',
  templateUrl: './justificativa-modal.component.html',
  styleUrls: ['./justificativa-modal.component.scss']
})
export class JustificativaModalComponent implements OnInit {

  dialogRef: MatDialogRef<JustificativaModalComponent>;

  listaMotivoCancelamentoNFS: CadastroGenerico[] = [];
  listaMotivoCancelamentoNFSFiltradas: Observable<CadastroGenerico[]>;

  isLoading = false;
  countLoading = 0;

  servico = false;

  private dialogData: {servico?: boolean} = {
  };

  form: UntypedFormGroup;

  constructor(
    private injector: Injector,
    private formBuilder: UntypedFormBuilder,
    private cadastroGenericoService: CadastroGenericoService,
    private snackBar: CustomSnackBarService,
    private authService: AuthService,
  ) {
    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
  }

  closeModal() {
    if (this.form.valid) {
      this.dialogRef.close({justificativa: this.form.controls['desJustificativa'].value, idMotivoCancelamento: this.form.controls['idMotivoCancelamentoNFS'].value});
    }
  }
  ngOnInit(): void {
    this.servico = this.dialogData?.servico ? true : false
    this.createForm();

    this.pesquisaCadastrosGenericos(
      'bas',
      'MotivoCancelamentoNFS',
      'motivoCancelamentoNFS',
      'idMotivoCancelamentoNFS',
      this.atualizaValoresListasMotivoCancelamentoNFS
    );
  }

  private createForm() {

    this.form = this.formBuilder.group({
      desJustificativa: [, Validators.compose([Validators.required, Validators.minLength(15), Validators.maxLength(255)])],

      motivoCancelamentoNFS: [,],
      idMotivoCancelamentoNFS: [,],
    });

    if(this.servico)
      this.form.controls["motivoCancelamentoNFS"].addValidators(Validators.required)
  }

  private exibirCarregando() {
    this.countLoading++;
    this.isLoading = true;
  }

  private escondeCarregando() {
    this.countLoading--;
    if (this.countLoading <= 0) {
      this.isLoading = false;
    }
  }

  private pesquisaCadastrosGenericos(
    modulo: string,
    assunto: string,
    campo: string,
    campoCodigo: string,
    functionRetornoLista
  ) {
    this.exibirCarregando()
    this.cadastroGenericoService
      .pesquisarPorModuloAssunto(modulo, assunto)
      .subscribe({
        next: (response) => {
          this.escondeCarregando();
          var lista = response.body.retorno.registro;

          if (!lista) {
            lista = [];
          }

          let codigoAux = this.form.controls[campoCodigo].value;

          if (codigoAux != 0) {
            let selecionado: CadastroGenerico = <CadastroGenerico>(
              lista.filter(
                (registro) => registro.codigoCadGenerico == codigoAux
              )[0]
            );

            if (selecionado) this.form.controls[campo].setValue(selecionado);
          }

          var listaFiltrada = this.form.controls[campo].valueChanges.pipe(
            startWith(''),
            map((value) =>
              typeof value === 'string' ? value : value.descricao
            ),
            map((name) => {
              return name
                ? this.filtraCadastroGenerico(lista, name)
                : lista.slice();
            })
          );

          functionRetornoLista(lista, listaFiltrada, this);
        },
        error: (err) => {
          this.escondeCarregando();
          TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
        },
      });
  }

  private filtraCadastroGenerico(
    lista: CadastroGenerico[],
    value: string
  ): CadastroGenerico[] {
    const filterValue = value.toLowerCase();
    return lista.filter((item) =>
      (item.codigo + " - " + item.descricao).trim().toLowerCase().includes(filterValue)
    );
  }

  verificaSeleciona(event, campo: string, campoCodigo: string) {
    if (event.srcElement.value === '') {
      this.form.controls[campo].setValue('');
      this.form.controls[campoCodigo].setValue(0);
    }
  }

  displayCadastroGenerico(registro: CadastroGenerico): string {
    return registro && registro.descricao ? registro.codigo + " - " + registro.descricao : '';
  }

  selecionaCadastroGenerico(event, campo: string) {
    let selecionado: CadastroGenerico = event.option.value;
    if (selecionado) {
      this.form.controls[campo].setValue(selecionado.codigoCadGenerico);
    }
  }

  atualizaValoresListasMotivoCancelamentoNFS(
    lista: CadastroGenerico[],
    listaFiltrada: Observable<[CadastroGenerico]>,
    self: any
  ) {
    self.listaMotivoCancelamentoNFS = lista;
    self.listaMotivoCancelamentoNFSFiltradas = listaFiltrada;
  }

  private showMessage(msg: string, type: string = "Success") {
    this.snackBar.openSnackBar(msg, null, type);
  }

}
